import PropTypes from 'prop-types'
import Moment from 'moment'

const validDateType = PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.instanceOf(Moment)])

export const dateRange = PropTypes.shape({
    end: validDateType,
    start: validDateType
})

export const intl = PropTypes.shape({
    formatDate: PropTypes.func,
    formatDateOnly: PropTypes.func,
    formatTimeOnly: PropTypes.func
})
